import {useSelector} from 'react-redux';

import {userSelector, isUnderLimit} from 'entities/user';

import {domainMonitorAPI} from '../api/domainMonitorAPI';

interface IDomainMonitorsLimit {
    activeCount: number | undefined,
    maxCount: number | undefined,
}

export const useDomainMonitorsLimit = (pollingInterval?: number): IDomainMonitorsLimit => {
    const user = useSelector(userSelector);
    const {data: summary} = domainMonitorAPI.useGetSummaryDomainMonitorsQuery(undefined, {pollingInterval});

    return {
        activeCount: summary?.total_active,
        maxCount: summary?.max ?? user?.tariff?.domain_monitor_max_count_limit,
    };
};

const useCanCreateDomainMonitor = (): boolean => {
    const {activeCount, maxCount} = useDomainMonitorsLimit();

    return isUnderLimit(maxCount, activeCount);
};

export default useCanCreateDomainMonitor;
